import { OddsView } from "./OddsView";

export const OddsPage = ({darkMode}) => {
  return <OddsView darkMode={darkMode}/>;
};

